import { Component } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { CaptureStorage } from './capture-storage';
import { CaptureExporter } from './capture-exporter';
import { CaptureModeService } from './capture-mode.service';

@Component({
  selector: 'app-capture-ui',
  standalone: true,
  imports: [ButtonModule],
  providers: [CaptureStorage, CaptureExporter, CaptureModeService],
  template: `
    @if (isEnabled) {
      <div class="capture-ui-panel">
        <h3>🎥 MSW Capture Mode</h3>
        <p>Captured: {{ captureCount }} requests</p>
        <div class="button-group">
          <button pButton label="Export JSON" (click)="exportJSON()"></button>
          <button pButton label="Export Files" (click)="exportFiles()"></button>
          <button pButton label="Clear" severity="danger" (click)="clearCaptures()"></button>
        </div>
      </div>
    }
  `,
  styles: [
    `
      .capture-ui-panel {
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: white;
        padding: 16px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 9999;
        min-width: 250px;
      }

      h3 {
        margin: 0 0 8px 0;
        font-size: 16px;
        font-weight: 600;
      }

      p {
        margin: 0 0 12px 0;
        color: #666;
      }

      .button-group {
        display: flex;
        gap: 8px;
        flex-direction: column;
      }
    `,
  ],
})
export class CaptureUIComponent {
  captureCount = 0;
  isEnabled: boolean;

  constructor(
    private captureStorage: CaptureStorage,
    private captureExporter: CaptureExporter,
    private captureModeService: CaptureModeService,
  ) {
    this.isEnabled = this.captureModeService.isEnabled;
    if (this.isEnabled) {
      this.initializeCaptureMode();
    }
  }

  private async initializeCaptureMode() {
    // Auto-clear old captures from previous sessions
    const oldCaptures = await this.captureStorage.getAllCaptures();
    if (oldCaptures.length > 0) {
      await this.captureStorage.clearCaptures();
      console.log(`🧹 Auto-cleared ${oldCaptures.length} old captured request(s) from previous session`);
      console.log('📸 Starting fresh - navigate the app to capture new endpoints');
    }

    // Start counting and update every 2 seconds
    this.updateCount();
    setInterval(() => this.updateCount(), 2000);
  }

  async updateCount() {
    const captures = await this.captureStorage.getAllCaptures();
    this.captureCount = captures.length;
  }

  async exportJSON() {
    await this.captureExporter.exportAsJSON();
    console.log('✅ Exported all captures as single JSON file');
  }

  async exportFiles() {
    await this.captureExporter.exportToFileSystem();
    console.log('✅ Exported captures as separate files by endpoint');
  }

  async clearCaptures() {
    await this.captureStorage.clearCaptures();
    this.captureCount = 0;
    console.log('✅ Cleared all captured requests');
  }
}
